/**
 *
 */

var Menu = (function($) {
  function initMenu() {
    $("body").toggleClass("has-nav");
  }

  function init() {
    // return early if no corresponding module present
    if (!$(".header").length) {
      return;
    }

    $(".hamburger").on("click", function() {
      initMenu();
    });

    $(document).on("click", 'a[href^="#"]', function(event) {
      event.preventDefault();

      $("html, body").animate(
        {
          scrollTop: $($.attr(this, "href")).offset().top + 200
        },
        1000
      );
    });
  }

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(Menu.init);
